import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import updateVehicleService from '../services/updateVehicleService';
import VehicleFormModal from '../components/VehicleFormModal';
import vehicleService from '../services/vehicleService';

class EditVehicleModal extends PureComponent {
  componentWillUpdate(nextProps) {
    const { vehicleId } = nextProps;
    if (vehicleId && vehicleId !== this.props.vehicleId) {
      this.props.dispatchVehicleGet(vehicleId);
    }
  }
  componentWillMount() {
    const { vehicleId } = this.props;
    if (vehicleId) {
      this.props.dispatchVehicleGet(vehicleId);
    }
  }
  handleSubmit = body => {
    this.props.dispatchUpdateVehiclePut(this.props.vehicleId, body);
  };
  render() {
    const {
      updateVehicleFetch,
      vehicleFetch,
      vehicleId,
      returnRoute,
      t,
      organisationId,
    } = this.props;
    if (!vehicleId) {
      return null;
    }
    return (
      <VehicleFormModal
        header={t('editVehicleWithLicensePlate', {
          licensePlate: get(vehicleFetch.value, 'licensePlate', '...'),
        })}
        onSubmit={this.handleSubmit}
        submitProcessing={!!updateVehicleFetch.pending}
        data={
          !vehicleFetch.fulfilled
            ? {}
            : {
                ...vehicleFetch.value,
                owner: {
                  ownedById:
                    vehicleFetch.value.ownedById === organisationId ? organisationId : undefined,
                  owner:
                    vehicleFetch.value.ownedById === organisationId
                      ? undefined
                      : vehicleFetch.value.owner,
                },
              }
        }
        dataLoading={!!vehicleFetch.pending}
        returnRoute={returnRoute}
        editMode
      />
    );
  }
}

EditVehicleModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchUpdateVehiclePut: PropTypes.func.isRequired,
  dispatchVehicleGet: PropTypes.func.isRequired,
  updateVehicleFetch: PropTypes.object.isRequired,
  vehicleFetch: PropTypes.object.isRequired,
  vehicleId: PropTypes.string,
  returnRoute: PropTypes.string.isRequired,
};

EditVehicleModal.defaultProps = {
  vehicleId: undefined,
};

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});

export default compose(
  connect(mapStateToProps),
  withTranslation(),
  updateVehicleService,
  vehicleService
)(EditVehicleModal);
